import HttpRequest from '../../lib/HttpRequest'

const api = new HttpRequest('facilities')
const actions = {
  exportToExcel: ({ commit }, payload) => api.post('export-to-excel', payload)
    .then(({ data }) => commit('facilities/exportedToExcel', data))
}

export default actions
